import Tracker from './Tracker';
import { labelEvents } from './FileBrowser';

const SegmentsTracker = new Tracker('Segments', {
	...labelEvents
});

export default SegmentsTracker;
